// Cart - Refresh on cart item change
const cartItemQuantitySelector = document.querySelectorAll(
	'.cart-item--quantity select.form-field-input'
);
const cartItemsRemoveButton = document.querySelectorAll(
	'.cart-item--remove-link'
);

if (cartItemQuantitySelector.length) {
	cartItemQuantitySelector.forEach((select) => {
		select.addEventListener('change', function () {
			setTimeout(function () {
				location.reload();
			}, 1000);
		});
	});
	cartItemsRemoveButton.forEach((btn) => {
		btn.addEventListener('click', function () {
			setTimeout(function () {
				location.reload();
			}, 1000);
		});
	});
}

// Product Landing Page updates
const accordions = document.querySelectorAll('.accordion');

function cycleAccordion(accordion) {
	let title = accordion.querySelector('.accordion--title');
	let content = accordion.querySelector('.accordion--body');

	title.addEventListener('click', function (e) {
		if (accordion.classList.contains('active')) {
			accordion.classList.remove('active');
		} else {
			accordion.classList.add('active');
		}
	});
}

accordions.forEach((accordion) => cycleAccordion(accordion));

// Remove content accordions from PLP content at large screen sizes
const plpContentBlocks = document.querySelectorAll(
	'.product-landing-page__content .content'
);

if (window.innerWidth > 991 || document.documentElement.clientWidth > 991) {
	plpContentBlocks.forEach((block) => {
		block.classList.remove('accordion');
	});
}
